import { render, staticRenderFns } from "./MCQQuestionInput.vue?vue&type=template&id=f6db5d68&scoped=true&"
import script from "./MCQQuestionInput.vue?vue&type=script&lang=js&"
export * from "./MCQQuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./MCQQuestionInput.vue?vue&type=style&index=0&id=f6db5d68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6db5d68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
